import gql from 'graphql-tag';

import multiUnitDropdownFragments from './MultiUnitDropdown/MultiUnitDropdown.fragments';
import multiUnitModalFragments from './MultiUnitModal/MultiUnitModal.fragments';

const multiUnitHitFragments = {
    Listing: gql`
        fragment MultiUnitHitListing on Listing {
            propertyMetadata {
                propertyName
            }
            propertyType
            listingId
            ...MultiUnitDropdownListing
            ...MultiUnitModalListing
        }
        ${multiUnitDropdownFragments.Listing}
        ${multiUnitModalFragments.Listing}
    `
};

export default multiUnitHitFragments;
